import { render, staticRenderFns } from "./MultiImageUploadButton.vue?vue&type=template&id=6aa009b6&"
import script from "./MultiImageUploadButton.vue?vue&type=script&lang=js&"
export * from "./MultiImageUploadButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports